/* eslint-disable */

import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarData = [
  {
    title: 'Reservas',
    path: '/reservas',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text'
  },
  {
    title: 'Buscador de Reservas',
    path: '/reservas-buscador',
    icon: <IoIcons.IoIosPaper />,
    cName: 'nav-text'
  },
  // {
  //   title: 'Actividades',
  //   path: '/actividades',
  //   icon: <IoIcons.IoIosPaper />,
  //   cName: 'nav-text'
  // }

];